import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../App";
import { Card, CardHeader, CardTitle, CardContent } from "./ui/card";
import TaskManagement from "./TaskManagement";

// Helper function to get local date in YYYY-MM-DD format
const getLocalDateString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export default function Tasks() {
  const { user } = useContext(AuthContext);
  const [selectedDate, setSelectedDate] = useState(getLocalDateString());

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-slate-800 flex items-center gap-2">
          Tasks & Action Items
        </h1>
        <p className="text-slate-600 mt-1">
          Manage tasks and action items for all your sites
        </p>
      </div>

      <Card>
        <CardContent className="p-4">
          <TaskManagement 
            siteId={null}
            selectedDate={selectedDate}
            compact={true}
          />
        </CardContent>
      </Card>
    </div>
  );
}
